import { CourseEmployeesReportFilterI } from 'types';
import { z } from 'zod';

export const courseEmployeesReportFilterSchema = z.object({
  fullName: z.string().optional(),
  department: z.string().optional(),
  jobTitle: z.string().optional(),
  jobTitleType: z.string().optional(),
  age: z.number().optional(),
  entryDate: z.string().optional(),
  terminalId: z.string().optional(),
  departmentId: z.string().optional(),
  jobTitleId: z.string().optional(),
  jobTitleTypeId: z.string().optional(),
  gender: z.string().optional(),
  minAge: z.number().optional(),
  maxAge: z.number().optional(),
  terminationDate: z.string().optional(),
  inscriptionDate: z.string().optional(),
});

export const defaultValue: CourseEmployeesReportFilterI = {
  fullName: '',
  department: undefined,
  jobTitle: undefined,
  jobTitleType: undefined,
  age: undefined,
  entryDate: undefined,
  terminalId: undefined,
  departmentId: undefined,
  jobTitleId: undefined,
  jobTitleTypeId: undefined,
  gender: undefined,
  minAge: undefined,
  maxAge: undefined,
  terminationDate: undefined,
  inscriptionDate: undefined,
};
